export default function setSeoContent() {
  const wrapper = document.querySelector('[data-seo-content]');
  if (!wrapper) return;

  const text = wrapper.querySelector('[data-seo-content-text]');
  const toggle = wrapper.querySelector('[data-seo-content-toggle]');
  if (!text || !toggle) return;

  if (text.scrollHeight <= text.clientHeight) return;

  toggle.hidden = false;

  toggle.addEventListener('click', () => {
    const expanded = text.classList.toggle('-expanded');
    toggle.textContent = expanded ? 'Ver menos' : 'Ver mais';
  });
}
